import { FC, forwardRef } from "react";
import { AllieItemProps } from "./Item.types";
import { StyledItem } from "./Item.styles";
import "./Item.css";

export const AllieItem: FC<AllieItemProps> = forwardRef(({
  allieColor = 'neutral',
  backgroundColor = 'white',
  lines = 'none',
  ...props
}, ref) => (
  <StyledItem
    allieColor={allieColor}
    backgroundColor={backgroundColor}
    lines={lines}
    ref={ref}
    {...props}
  />
));
